import {isHtoActive} from '../feature-flags'
import * as URLS from '../urls'

const legacyLinks = [
  {
  links: [
    {
      title: 'Suits & Tuxedos',
      toSpa: true,
      url: URLS.COLLECTION_TUXEDOS_SUITS,
    },
    {
      title: 'Shirts',
      toSpa: true,
      url: URLS.COLLECTION_SHIRTS,
    },
    {
      title: 'Vests',
      toSpa: true,
      url: URLS.COLLECTION_VESTS,
    },
    {
      title: 'Cufflinks & Studs',
      toSpa: true,
      url: URLS.COLLECTION_CUFFLINKS_STUDS,
    },
    {
      title: 'Neckwear',
      toSpa: true,
      url: URLS.COLLECTION_NECKWEAR,
    },
    {
      title: 'Shoes',
      toSpa: true,
      url: URLS.COLLECTION_SHOES,
    },
    {
      title: 'Accessories',
      toSpa: true,
      url: URLS.COLLECTION_ACCESSORIES,
    },
  ],
  title: 'Rental',
},
{
  links: [
    {
      title: 'New Arrivals',
      toSpa: false,
      url: `${URLS.BUY_NEW_COLLECTIONS}/new-arrivals`,
    },
    {
      title: 'Suits & Tuxedos',
      toSpa: true,
      url: `${URLS.COLLECTION_TUXEDOS_SUITS}/buy`,
    },
    {
      title: 'Shirts',
      toSpa: true,
      url: `${URLS.COLLECTION_SHIRTS}/buy`,
    },
    {
      title: 'Vests',
      toSpa: true,
      url: `${URLS.COLLECTION_VESTS}/buy`,
    },
    {
      title: 'Cufflinks & Studs',
      toSpa: true,
      url: `${URLS.COLLECTION_CUFFLINKS_STUDS}/buy`,
    },
    {
      title: 'Neckwear',
      toSpa: true,
      url: `${URLS.COLLECTION_NECKWEAR}/buy`,
    },
    {
      title: 'Shoes',
      toSpa: true,
      url: `${URLS.COLLECTION_SHOES}/buy`,
    },
    {
      title: 'Accessories',
      toSpa: true,
      url: `${URLS.COLLECTION_ACCESSORIES}/buy`,
    },
    {
      title: 'Sale',
      toSpa: false,
      url: `${URLS.BUY_NEW_COLLECTIONS}${URLS.SALE_COLLECTION}`,
    },
  ],
  hasDivider: false,
  marketingText: 'The new way to own your look.',
  title: 'Buy New',
},
{
  links: [
    {
      title: 'Our Process',
      toSpa: true,
      url: URLS.HOW_IT_WORKS,
    },
    {
      title: 'Fit & Sizing',
      toSpa: true,
      url: URLS.FIT_LP,
    },
    {
      title: 'A Quality Suit',
      toSpa: true,
      url: URLS.OUR_QUALITY,
    },
    {
      title: 'Prom',
      toSpa: false,
      url: URLS.PROM,
    },
    {
      title: 'Weddings',
      toSpa: true,
      url: URLS.WEDDINGS_LP,
    },
    {
      title: 'Rentals',
      toSpa: true,
      url: URLS.TUXEDO_SUIT_RENTAL,
    },
  ],
  title: 'How It Works',
},
{
  links: [],
  url: URLS.HOME_TRY_ON,
  title: 'Home Try-On',
  toSpa: true,
},
]

const mobileMenuConfig = {
  accordions: [
    {
      links: [],
      url: URLS.SHOWROOMS,
      title: 'Showrooms',
      toSpa: true,
    },
    {
      links: [],
      url: 'https://markenyc.com/pages/wedding-rings?utm_source=theblacktux&utm_medium=referral&utm_campaign=nav',
      target: '_blank',
      title: 'Wedding Rings',
      toSpa: false,
    },
  ],
  footerColumns: [
    [
    //   {
    //     title: 'Suit & Tux Rental',
    //     toSpa: true,
    //     url: URLS.TUXEDO_SUIT_RENTAL,
    //   },
    //   {
    //     title: 'Our Story',
    //     toSpa: true,
    //     url: URLS.OUR_STORY,
    //   },
      {
        title: 'Careers',
        toSpa: true,
        url: URLS.CAREERS,
      },
    //   {
    //     title: 'Accessibility',
    //     toSpa: true,
    //     url: URLS.ACCESSIBILITY,
    //   },
    //   {
    //     title: 'The Blog',
    //     toSpa: false,
    //     url: URLS.BLOG,
    //   },
    // ],
    // [
    //   {
    //     target: '_blank',
    //     title: 'Help Center',
    //     toSpa: false,
    //     url: URLS.HELP_CENTER,
    //   },
    //   {
    //     title: 'Fit Guarantee',
    //     toSpa: true,
    //     url: URLS.FIT_GUARANTEE,
    //   },
    //   {
    //     title: 'Rental Agreement',
    //     toSpa: true,
    //     url: URLS.RENTAL_AGREEMENT,
    //   },
    //   {
    //     title: 'Return Policy',
    //     toSpa: true,
    //     url: URLS.RETURN_POLICY,
    //   },
    ],
  ],
}

const mobileMenuConfigWithoutHto = {
  ...mobileMenuConfig,
  accordions: mobileMenuConfig.accordions.filter(({url}) => url !== URLS.HOME_TRY_ON),
}

export default isHtoActive ? mobileMenuConfig : mobileMenuConfigWithoutHto
